import React, { ReactElement } from 'react'
import Image from 'next/image'
import src from '../../../../../public/splashPage/avatars/sue.webp'

export const SueImage: React.FC<unknown> = (): ReactElement => (
    <Image src={src} alt={'Sue'} />
)
